module.exports = __webpack_public_path__ + "static/img/face1a.a92c7d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/face1a.png
// module id = 95BH
// module chunks = 1